{
  "name": "55-Heart of Tones",
  "description": "55-tone layout of 1200edo (1 cent steps) based on Pauline Oliveros’s \"Heart of Tones\". The central tone D expands outward by about a semitone on each side.",
  "scale": [
    "1.0",
    "2.0",
    "3.0",
    "4.0",
    "5.0",
    "6.0",
    "7.0",
    "8.0",
    "9.0",
    "10.0",
    "11.0",
    "12.0",
    "13.0",
    "14.0",
    "15.0",
    "16.0",
    "17.0",
    "18.0",
    "19.0",
    "20.0",
    "21.0",
    "22.0",
    "23.0",
    "24.0",
    "25.0",
    "26.0",
    "27.0",
    "28.0",
    "29.0",
    "30.0",
    "31.0",
    "32.0",
    "33.0",
    "34.0",
    "35.0",
    "36.0",
    "37.0",
    "38.0",
    "39.0",
    "40.0",
    "41.0",
    "42.0",
    "43.0",
    "44.0",
    "45.0",
    "46.0",
    "47.0",
    "48.0",
    "49.0",
    "50.0",
    "51.0",
    "52.0",
    "53.0",
    "54.0",
    "55.0"
  ],
  "key_colors_mode": "manual",
  "short_description": "55-Oliveros",
  "built_in_group": "Equal Divisions",
  "key_labels": "note_names",
  "note_names": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
    "25",
    "25",
    "26",
    "27",
    "-27",
    "-26",
    "-25",
    "-24",
    "-23",
    "-22",
    "-21",
    "-20",
    "-19",
    "-18",
    "-17",
    "-16",
    "-15",
    "-14",
    "-13",
    "-12",
    "-11",
    "-10",
    "-9",
    "-8",
    "-7",
    "-6",
    "-5",
    "-4",
    "-3",
    "-2",
    "-1"
  ],
  "note_colors": [
    "#ffdbdb",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#f5ffe0",
    "#fbf6e0",
    "#ffffff",
    "#d8f7fd",
    "#ddfde3",
    "#bab4c0",
    "#adadad",
    "#b5a5ca",
    "#ada5c0",
    "#f5ffe0",
    "#fbf6e0"
  ],
  "equivSteps": 55,
  "fundamental": 293.333333,
  "reference_degree": 0,
  "center_degree": 0,
  "rSteps": 9,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -16.102113751
}
